module.exports = __webpack_public_path__ + "assets/images/USD010.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD010.png
// module id = 1448
// module chunks = 1